export default __webpack_public_path__ + "bca44379a671f3fe6b13150a1eaaf1f8.png";